import { Button, Counter } from 'front-commons/ds';
import { AddToBasketButtonRenderProps } from './interfaces';

export default function AddToBasketButtonRender({
	loading,
	loadingBasket,
	leftIcon,
	disabled,
	quantity,
	contextQuantity,
	counterOptions,
	onAdd,
	onChange,
	onRemove,
	onBlur,
	hasPermission,
	allowZero = false,
	width,
	label,
	maxQuantity,
	progressLoading,
	loadingCounter,
}: AddToBasketButtonRenderProps) {
	const loadingAddButton = loading === 'add' || loadingBasket === 'full' || !!(!quantity.amount && contextQuantity);

	const shouldShowCounter = quantity.method === 'typing' || Number(quantity.amount) > 0 || allowZero;

	const forceAmount = (amount: number | '') => {
		// when the input is empty
		if (!amount && amount !== 0) return '';

		// when the amount is above maxQuantity
		if (!!maxQuantity && amount > maxQuantity) return maxQuantity;

		return amount;
	};

	if (loadingCounter || (!(progressLoading && loadingAddButton && loadingBasket !== 'full') && shouldShowCounter)) {
		return (
			<Counter
				quantity={quantity.amount}
				initialQuantity={contextQuantity}
				onAdd={() => onChange({ method: 'increment' })}
				onRemove={() => onRemove()}
				onChange={(value) => onChange({ amount: forceAmount(value), method: 'typing' })}
				onBlur={onBlur}
				loading={loading || !!loadingCounter ? 'typing' : false}
				disabled={disabled}
				hasPermission={hasPermission}
				data-testid="add-to-cart-counter"
				maxQuantity={maxQuantity || undefined}
				{...counterOptions}
			/>
		);
	}

	return (
		<Button
			onClick={() => {
				onAdd();
			}}
			width={width || '100%'}
			maxWidth={width ? undefined : { small: '124px', medium: '128px' }}
			variant="primary"
			leftIcon={leftIcon}
			rightIcon={label ? undefined : { name: 'shopping_cart' }}
			loading={loadingAddButton}
			disabled={disabled}
			hasPermission={hasPermission}
			progressLoading={progressLoading}
			data-testid="add-to-cart"
		>
			{label || 'Adicionar'}
		</Button>
	);
}
